//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    constants: {
        monthNames: 'leden,únor,březen,duben,květen,červen,červenec,srpen,září,říjen,listopad,prosinec'.split(','),

        // Values copied from SCSS below
        dayHeaderHeight: 28,
        dayWidth: 32,
        dayHeight: 34,

        minClientFilterTextLength: 3,
    },

    data() {
        return {
            from: dayjs().valueOf(),
            to: dayjs().valueOf(),
            months: [],
            addingMonths: null,
            noScroll: false,
            scrollX: null,
            scrollY: null,
            filterText: '',
            suggestedClientFilterText: '',
        };
    },

    computed: {
        rows() {
            if (this.clientFilteredCases)
                return $.vehicles.filter(v => this.clientFilteredCases.some(c => c.vehicleRef === v.id));

            if (this.filterText)
                return $.vehicles.filter(this.vehicleFilterFn);

            return $.vehicles;
        },
        rowCount() {
            return this.rows.length;
        },
        caseEntries() {
            let cases = this.clientFilteredCases || $.cases;

            cases = cases.filter(c => (
                dayjs(c.to).isSameOrAfter(_.first(this.months), 'month') &&
                dayjs(c.from).isSameOrBefore(_.last(this.months), 'month')
            ));

            $.actualizeRefOnDemand('cases', cases, 'clientRef');
            $.actualizeRefOnDemand('clients', _.uniq(cases.map(c => c.client).filter(v => v)), 'personRef');

            return cases.map(this.caseToEntry).filter(v => v);
        },
        clientFilteredCases() {
            if (this.filterText?.startsWith('KLIENT ')) {
                const text = this.filterText.substr(7).trim();
                const clients = $.clients.filter(c => this.clientFilterFn(c, text));
                const cases = $.cases.filter(c => clients.some(cl => cl.id === c.clientRef));

                return cases;
            }

            return null;
        },
    },

    methods: {
        getVehicleName(vehicle) {
            return [vehicle.make, vehicle.model, vehicle.variant, vehicle.rz].filter(x => x).join(' ');
        },
        getClientName(client) {
            $.actualizeRefOnDemand('clients', client, 'personRef');

            return client.person ? `${client.person.firstName} ${client.person.lastName}` : client.companyName;
        },
        getDayClasses(djs) {
            return [
                [0, 6].includes(djs.day()) && 'weekend',
                djs.isSame(dayjs(), 'day') && 'today',
            ];
        },
        vehicleFilterFn(vehicle) {
            return $.filterByCsvFieldPaths(vehicle, 'make model,rz,vin', this.filterText);
        },
        clientFilterFn(client, text) {
            return $.filterByCsvFieldPaths(client, 'person.firstName person.lastName,companyName', text);
        },
        caseToEntry(c) {
            const rowIdx = this.rows.findIndex(r => r.id === c.vehicleRef);

            if (rowIdx === -1)
                return null;

            return {
                id: c.id,
                fromToStr: $.formatDateRange(c.from, c.to),
                clientStr: c.isInternal ? 'Interní' : !c.client ? null : c.client.person ? `${c.client.person.firstName} ${c.client.person.lastName}` : c.client.companyName,
                isInternal: c.isInternal,
                x: dayjs(c.from).diff(this.months[0].startOf('month'), 'days', true) * this.dayWidth,
                y: rowIdx * this.dayHeight,
                width: dayjs(c.to).diff(c.from, 'days', true) * this.dayWidth,
            };
        },
        checkClients(text) {
            if (this.filterText?.startsWith('KLIENT ')) {
                this.suggestedClientFilterText = '';
                return;
            }

            this.suggestedClientFilterText = (
                this.filterText &&
                this.filterText.length >= this.minClientFilterTextLength &&
                $.clients.some(c => this.clientFilterFn(c, this.filterText))
            ) ? text : '';
        },
        setClientFilterPrefix() {
            this.filterText = `KLIENT ${this.filterText}`;
            this.suggestedClientFilterText = '';
        },
        async initMonths() {
            if (!this.from || !this.to)
                return;

            const first = dayjs(this.from).subtract(1, 'month').endOf('month');
            const last = dayjs(this.to).add(1, 'month').endOf('month');
            const months = [first];

            let m = first;

            while (m.month() !== last.month() || m.year() !== last.year()) {
                m = m.add(1, 'month').endOf('month');

                months.push(m);
            }

            this.months = months;

            this.$nextTick(() => this.scrollToDate(this.from));
        },
        scrollToDate(value) {
            const hScroll = this.$refs.timeline;
            const left = this.dayWidth * dayjs(value).diff(this.months[0].startOf('month'), 'days');
            const centered = left - hScroll.$el.clientWidth / 2;

            hScroll.setScrollPosition(centered);
        },
        syncedVerticalScroll(source, position) {
            if (this.ignoreSource === source) {
                this.ignoreSource = null;
                return;
            }

            if (source === 'vehicles') {
                this.ignoreSource = 'timeline';
                this.$refs.timeline.$el.querySelector('.scroll').scrollTop = position;
            } else {
                this.ignoreSource = 'vehicles';
                this.$refs.vehicles?.setScrollPosition(position);
            }
        },
        async addMonths(side) {
            this.noScroll = true;
            this.addingMonths = side;

            await $.delay(500);

            if (side === 'left') {
                const m = _.first(this.months).subtract(1, 'month').endOf('month');

                this.months.unshift(m);

                this.$refs.timeline?.setScrollPosition(m.date() * this.dayWidth);
            } else if (side === 'right') {
                const m = _.last(this.months).add(1, 'month').endOf('month');

                this.months.push(m);
            }

            this.addingMonths = null;

            await $.delay(100);

            this.noScroll = false;
        },
        onScrollVehicles({ verticalPosition }) {
            this.syncedVerticalScroll('vehicles', verticalPosition);
        },
        onScrollTimeline() {
            const el = this.scrollEl;
            const x = el.scrollLeft;
            const y = el.scrollTop;

            if (this.scrollX !== x) {
                if (x === 0) {
                    this.addMonths('left');
                } else if (x === el.scrollWidth - el.clientWidth) {
                    this.addMonths('right');
                }
            }

            if (this.scrollY !== y) {
                this.syncedVerticalScroll('timeline', y);
            }

            this.scrollX = x;
            this.scrollY = y;
        },
        onUpdateDateRange({ from, to }) {
            this.from = from;
            this.to = to;

            this.initMonths();
        },
        onClick({ id }) {
            $.goToDetail('cases', id);
        },
        onKeyDown(ev) {
            if (ev.which === 70 && ev.ctrlKey) {
                ev.preventDefault();

                this.$refs.filter.$el.querySelector('input').focus();
            }
        },
    },

    mounted() {
        this.scrollEl = this.$refs.timeline.$el.querySelector('.scroll');

        this.scrollEl.addEventListener('scroll', this.onScrollTimeline);

        this.initMonths();

        window.addEventListener('keydown', this.onKeyDown);
    },

    beforeDestroy() {
        window.removeEventListener('keydown', this.onKeyDown);
    },
};
